"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g = Object.create((typeof Iterator === "function" ? Iterator : Object).prototype);
    return g.next = verb(0), g["throw"] = verb(1), g["return"] = verb(2), typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.UserEditPage = UserEditPage;
var jsx_runtime_1 = require("react/jsx-runtime");
var react_1 = require("@heroui/react");
var react_2 = require("@iconify/react");
var react_3 = require("react");
var react_router_dom_1 = require("react-router-dom");
var user_1 = require("../../../features/apis/user");
var hooks_1 = require("../../../store/hooks");
var user_form_1 = require("./user-form");
function UserEditPage() {
    var _this = this;
    var userId = (0, react_router_dom_1.useParams)().userId;
    var navigate = (0, react_router_dom_1.useNavigate)();
    var _a = (0, hooks_1.useAppSelector)(function (state) { return state.auth; }), clientId = _a.clientId, currentUserRole = _a.role;
    var isAdmin = currentUserRole === "Admin";
    var data = (0, user_1.useFetchUsersQuery)({ clientId: clientId, page: 1, limit: 100 }, { skip: !clientId }).data;
    var updateUser = (0, user_1.useUpdateUserMutation)()[0];
    var _b = (0, react_3.useState)("view"), mode = _b[0], setMode = _b[1];
    var user = (0, react_3.useMemo)(function () {
        var _a;
        var users = ((_a = data === null || data === void 0 ? void 0 : data.content) === null || _a === void 0 ? void 0 : _a.users) || [];
        return users.find(function (u) { return u._id === userId; }) || null;
    }, [data, userId]);
    var isLoading = !data;
    var notFound = data && !user;
    var handleUserUpdate = function (formPayload) { return __awaiter(_this, void 0, void 0, function () {
        var response, error_1, message;
        var _a;
        return __generator(this, function (_b) {
            switch (_b.label) {
                case 0:
                    _b.trys.push([0, 2, , 3]);
                    return [4 /*yield*/, updateUser({
                            _id: formPayload._id,
                            name: formPayload.name,
                            firstName: formPayload.firstName,
                            lastName: formPayload.lastName,
                            email: formPayload.email,
                            role: formPayload.role,
                            gender: formPayload.gender,
                            contactNumber: formPayload.contactNumber,
                        }).unwrap()];
                case 1:
                    response = _b.sent();
                    if (response.success) {
                        (0, react_1.addToast)({
                            title: "User Updated",
                            description: "User \"".concat(formPayload.firstName, " ").concat(formPayload.lastName, "\" has been updated successfully."),
                            color: "success",
                        });
                        setMode("view");
                    }
                    else {
                        (0, react_1.addToast)({
                            title: "Update Failed",
                            description: response.message || "Could not update user.",
                            color: "danger",
                        });
                    }
                    return [3 /*break*/, 3];
                case 2:
                    error_1 = _b.sent();
                    message = ((_a = error_1 === null || error_1 === void 0 ? void 0 : error_1.data) === null || _a === void 0 ? void 0 : _a.message) || "An error occurred while updating the user.";
                    (0, react_1.addToast)({
                        title: "Update Failed",
                        description: message,
                        color: "danger",
                    });
                    return [3 /*break*/, 3];
                case 3: return [2 /*return*/];
            }
        });
    }); };
    var handleCancel = function () {
        if (mode === "edit") {
            setMode("view");
        }
        else {
            navigate("/dashboard/users");
        }
    };
    var handleBack = function () {
        navigate("/dashboard/users");
    };
    var isViewMode = mode === "view";
    var isEditMode = mode === "edit";
    if (isLoading) {
        return ((0, jsx_runtime_1.jsx)("div", { className: "flex h-full items-center justify-center", children: (0, jsx_runtime_1.jsx)(react_1.Spinner, { size: "lg" }) }));
    }
    if (notFound) {
        return ((0, jsx_runtime_1.jsxs)("div", { className: "flex h-full flex-col items-center justify-center gap-4", children: [(0, jsx_runtime_1.jsx)(react_2.Icon, { icon: "solar:user-cross-linear", className: "text-6xl text-gray-400" }), (0, jsx_runtime_1.jsx)("h2", { className: "text-xl font-semibold text-gray-700", children: "User Not Found" }), (0, jsx_runtime_1.jsx)("p", { className: "text-gray-500", children: "The user you're looking for doesn't exist or has been removed." }), (0, jsx_runtime_1.jsx)(react_1.Button, { color: "primary", variant: "flat", onPress: function () { return navigate("/dashboard/users"); }, children: "Back to Users" })] }));
    }
    return ((0, jsx_runtime_1.jsxs)("div", { className: "flex h-full flex-col gap-3", children: [(0, jsx_runtime_1.jsx)("div", { className: "rounded-xl bg-white p-4 shadow-sm md:p-6", children: (0, jsx_runtime_1.jsxs)("div", { className: "flex items-center justify-between", children: [(0, jsx_runtime_1.jsxs)("div", { className: "flex flex-col gap-1", children: [(0, jsx_runtime_1.jsxs)(react_1.Breadcrumbs, { size: "sm", children: [(0, jsx_runtime_1.jsx)(react_1.BreadcrumbItem, { onPress: function () { return navigate("/dashboard/users"); }, children: "Users" }), (0, jsx_runtime_1.jsx)(react_1.BreadcrumbItem, { children: isEditMode ? "Edit User" : "View User" })] }), (0, jsx_runtime_1.jsxs)("div", { className: "flex items-center gap-3", children: [(0, jsx_runtime_1.jsx)("h1", { className: "text-xl font-bold text-gray-800", children: isEditMode ? "Edit User" : "View User" }), (0, jsx_runtime_1.jsx)("span", { className: "text-sm text-gray-500", children: user === null || user === void 0 ? void 0 : user.name }), user && ((0, jsx_runtime_1.jsx)(react_1.Chip, { size: "sm", variant: "flat", color: user.isActive ? "success" : "danger", children: user.isActive ? "Active" : "Inactive" }))] })] }), (0, jsx_runtime_1.jsxs)("div", { className: "flex items-center gap-2", children: [isViewMode && isAdmin && ((0, jsx_runtime_1.jsx)(react_1.Button, { variant: "flat", color: "primary", size: "sm", startContent: (0, jsx_runtime_1.jsx)(react_2.Icon, { icon: "solar:pen-linear" }), onPress: function () { return setMode("edit"); }, children: "Edit" })), (0, jsx_runtime_1.jsx)(react_1.Button, { variant: "light", size: "sm", startContent: (0, jsx_runtime_1.jsx)(react_2.Icon, { icon: "solar:arrow-left-linear" }), onPress: handleBack, children: "Back to Users" })] })] }) }), (0, jsx_runtime_1.jsx)("div", { className: "rounded-xl bg-white p-4 shadow-sm md:p-6", children: (0, jsx_runtime_1.jsx)(user_form_1.UserForm, { mode: mode, variant: "page", initialData: user || undefined, onSubmit: handleUserUpdate, onCancel: handleCancel }) })] }));
}
